
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.626 44.6c-.5-6.9-.9-13.7-1.4-20.6-.1-2.2.7-11.1-1.9-12.5-.1-.1-.2-.1-.3-.1h-6.4v-1.3c-.1-4.7-3.2-7.1-7.7-7.1-4.4 0-7.5 2.2-7.8 6.9v1.5h-2.5c-1.1 0-3.1-.4-4.1.1-2.5 1.2-1.7 7.7-1.8 9.8-.4 6.6-.9 13.3-1.3 19.9-.1 2.1-1.4 6.9 1.1 8 1 .4 3.1 0 4.1 0h9.4c6 0 12.1.4 18 0 2.9-.2 2.8-2 2.6-4.6zm-17.7-38.4c3.5 0 6.4 1.3 6.4 5.3h-12.8c.1-3.9 2.7-5.3 6.4-5.3zm14.6 39.9c-4.5-.8-10 0-14.7 0h-8.5c-2 0-4.7-.5-6.6 0-.4.1-.8 0-1.2 0-.4 0-.3.4-.3.7-.5-1 .3-4 .3-5.1.6-5.8 1-11.5 1.4-17.3.2-2.4.3-4.7.5-7.1 0-.6-.1-1.7.1-2.2.1-.3.2-.4.2-.5h.1c.8-.5 4 0 5 0h1.4v.6c-1.4.4-2.3 1.8-2.3 3.3 0 1.7 1.1 3.3 2.8 3.4 1.8.1 2.9-1.4 3.1-3 0-.1.1-.2 0-.4v-.4c-.2-1.3-.9-2.6-2.3-2.9v-.6h12.8v.6c-1.4.4-2.3 1.8-2.3 3.3 0 1.7 1.1 3.3 2.8 3.4 1.8.1 2.9-1.4 3.1-3 0-.1.1-.2 0-.4v-.4c-.2-1.3-.9-2.6-2.2-2.9v-.6h6.5c0 .1 0 .2.1.5.2.6.1 1.3.1 1.9.2 2.6.4 5.2.5 7.9.4 5.6.8 11.2 1.1 16.8.1 1.1.6 3.2.4 4.5-.1 0-.2-.1-.3-.1-.5-.1-1 .1-1.6 0z"}})])
          )
        }
      }
    